import React, {useState, useEffect} from 'react';
import * as S from './NameChangeInfoBlock.styles';

import {validations} from '../../../../utils/validations';

//{dateInfo, roomInfo, fcdt, updateParams, checkAvailability, isCheckAvailabilityDisabled}
const NameChangeInfoBlock = ({tripDetails, submitChange}) => {
  const [{first_name, last_name}, setNewName] = useState({
    first_name: '',
    last_name: ''
  });

  const [errors, setError] = useState({});

  const fieldValidators = {
    'first_name': {'field': 'firstName', 'fieldName': 'firstname', 'validators': ['required', 'alpha']},
    'last_name': {'field': 'lastName', 'fieldName': 'lastname', 'validators': ['required', 'alpha']}
  };

  const validateFields = (data) => {
    let errorObj = {};
    Object.keys(data).map(key => {
      if (fieldValidators[key]) {
        const validators = fieldValidators[key].validators;
        for (let i = 0; i < validators.length; i++) {
          const validateFunction = validations[validators[i]];
          const resp = validateFunction({
            value: data[key],
            fieldName: fieldValidators[key].fieldName
          });
          if (resp && !errorObj[key]) {
            errorObj[key] = resp;
          }
        }
      }
    });
    setError(errorObj);
    if (Object.keys(errorObj).length) {
      return true;
    }
    return false;
  }


  const submitUserInfo = (event: React.FormEvent) => {
    event.preventDefault();
    const data = {
      first_name,
      last_name
    };
    const hasError = validateFields(data);
    if (!hasError) {
      submitChange(data);
    }
  };

  const onChangeHandler = (field, value) => {
    const data = {
      first_name,
      last_name
    };
    data[field] = value;
    setNewName(data);
  }

  return(
    <S.RescheduleInfoMainWrap>
      <S.InfoBlockHeadWrap>
        <S.InfoBlockHeadText>Change Name</S.InfoBlockHeadText>
        <S.InfoBlockSubText>You can change the name of primary guests. </S.InfoBlockSubText>
      </S.InfoBlockHeadWrap>
      <S.OldNameWrap>
          <S.OldNameTitle>Old Name:&nbsp;</S.OldNameTitle>
          <S.OldNameText>{tripDetails.name}</S.OldNameText>
      </S.OldNameWrap>
      <S.UserInfoForm onSubmit={submitUserInfo}>
        <S.NewNameOuterWrap>
            <S.NameNameTitle>New Name: &nbsp;</S.NameNameTitle>
            <S.NewNameInnerWrap>
                <S.NewFirstNameWrap>
                  <S.NewNameInput 
                    type="text"
                    name="firstname"
                    placeholder="First Name"
                    value={first_name}
                    onChange={event => onChangeHandler('first_name', event.target.value)}
                    hasError={errors['first_name'] ? true : false}
                    />
                    <S.ErrorText>{errors['firstname']}</S.ErrorText>
                </S.NewFirstNameWrap>
                <S.NewLastNameWrap>
                  <S.NewNameInput 
                    type="text"
                    name="lastname"
                    placeholder="Last Name"
                    value={last_name}
                    onChange={event => onChangeHandler('last_name', event.target.value)}
                    hasError={errors['last_name'] ? true : false}
                    />
                    <S.ErrorText>{errors['lastname']}</S.ErrorText>
                </S.NewLastNameWrap>
            </S.NewNameInnerWrap>
        </S.NewNameOuterWrap>
        <S.RefundBtnWrap >
        {/* <S.RefundBtnWrap  disabled={disabled} onClick={checkAvailability}> */}
          <S.RefundBtn>SUBMIT CHANGE</S.RefundBtn>
        </S.RefundBtnWrap>
      </S.UserInfoForm>
    </S.RescheduleInfoMainWrap>
  );
};

export default NameChangeInfoBlock;